<template>
    <app-ghost-mode>
        <div class="row">
            <div class="col-12">
                <div class="jumbotron screen-center text-center">
                    <form v-if="item">
                        <div class="negotiate-header bg-warning text-dark pt-3">
                            <h3 class="md-small-text"><i class="fas fa-fire"></i> aNewItem Promotions</h3>
                        </div>
                        <!-- Alert Messages -->
                        <dl v-if="msg !== ''" class="row mt-4">
                            <dd class="col-12">
                                <div :class="`alert alert-${color} text-center mb-n5 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg | capitalize }}
                                </div>
                            </dd>
                        </dl>
                        <div v-if="thePromotionPlans" class="mt-4 mb-n4">
                            <template v-if="item.promoted">
                                <ul class="list-group text-left">
                                    <li class="list-group-item text-center">
                                        You have applied a promotion plan on this item. <br>
                                        <!-- transaction receipt link -->
                                        <router-link v-if="itemTransaction" :to="{ name: 'transactions' }" tag="button" class="text-dark btn btn-light mr-2">
                                            <i class="fas fa-receipt text-dark-green"></i> {{itemTransaction.number}}
                                        </router-link>
                                    </li>
                                </ul>
                                <button @click.prevent="demoteItemFxn" class="mt-3 loadn btn btn-danger"><i class="fas fa-times"></i> End Promotion Now</button>
                            </template>
                            <template v-else>
                                <ul class="list-group text-left">
                                    <li class="list-group-item">
                                        Select the promotion plan you want to apply on this item
                                    </li>
                                    <li class="card-body pre-scrollable p-0">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item" v-for="(plan, i) in thePromotionPlans" :key="i">
                                                <input v-model="selectedPlan" type="radio" name="selectedPlanRadio" :id="i" :value="plan"> 
                                                <label :for="i" class="mx-2 clickable" :title="plan.description | capitalize">
                                                    <span class="font-weight-bold">{{plan.name | capitalize}}</span> 
                                                    {{plan.price}} {{plan.currency.toUpperCase()}}
                                                </label> 
                                                <i @click="clickedPlanFxn(plan._id)" class="fas fa-info-circle text-muted clickable" title="learn more"></i>
                                                <template v-if="clickedPlan == plan._id && showDescription">
                                                    <br><small class="m-0">{{plan.description | capitalize}}</small>
                                                </template>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <button @click.prevent="promoteItemFxn" class="mt-3 loadn btn btn-warning">Apply Promotion</button>
                            </template>
                        </div>
                        <div v-else class="mt-4 mb-n4">
                            <ul class="list-group text-left">
                                <li class="list-group-item text-center">
                                    Unfortunately, item promotion is yet to be available for {{user.country | capitalize}}, check back soon.
                                </li>
                            </ul>
                        </div>
                    </form>
                    <div v-else class="text-center text-danger">Ooops! You're missing the item!</div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "Promotions",
    props: ['itemId'],
    data() {
        return {
            price: '',
            msg: '',
            color: 'danger',
            selectedPlan: '',
            clickedPlan: '',
            showDescription: false
        }
    },
    methods: {
        ...mapActions(['listPostedItem', 'fetchPromotionPlans', 'fetchTransactions', 'promoteItem', 'demoteItem', 'createTransaction', 'completePromoteItem']),
        clickedPlanFxn(value){
            // check if the btn was clicked twice - toggle
            if(this.clickedPlan == value){
                this.clickedPlan = ''
                return this.showDescription = false
            }
            // display the clicked plans description
            this.clickedPlan = value
            this.showDescription = true
        },
        runFetchItemDetails() {
            // fetch the new item details using the itemId
            this.listPostedItem(this.itemId)
            .then(() => {
                this.fetchPromotionPlans()
                this.runFetchTransaction()
            })
        },
        promoteItemFxn() {
            this.color = "danger"
            if(this.selectedPlan === ''){ this.msg = "Select a plan to proceed"; return }
            /*
            *   temp store the users selecetedPlan in localStorage so after the payment gateway redirects 
            *   to this page we can use it to send the final api request to give user value for their money
            */
            localStorage.setItem('_m12sp60u', JSON.stringify(this.selectedPlan))
            var itemObj = {
                itemId: this.item._id,
                userId: this.item.userId,
                plan: this.selectedPlan.codeName,
                cost: this.selectedPlan.price,
                duration: this.selectedPlan.duration,
                currency: this.selectedPlan.currency,
                link: `/market/listItem/${this.item._id}`, // for story
                linkText: this.item.title // for story
            }
            this.promoteItem(itemObj)
            .then((data) => {
                if(!data.error){ 
                    this.color = "success" 
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = "Promoting item failed, try again."
            })
        },
        demoteItemFxn() {
            let itemObj = {
                itemId: this.item._id,
                promotionId: this.item.promotionId,
            }
            // vuejs-dialog usage for pop up confirmations
            // https://github.com/Godofbrowser/vuejs-dialog
            let message = "<center>This will immediately end the promotion on this item. No refunds! Do you want to proceed ?</center>";
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                this.demoteItem(itemObj)
                .then((data) => {
                    this.color = !data.error ? "success" : "danger",
                    this.msg = data.msg
                })
                .catch((e) => {})
            })
            .catch((e) => {})
        },
        runFetchTransaction() {
            let transactionObj = {
                userId: this.user._id,
                itemId: this.item._id,
                promotionId: this.item.promotionId,
            }
            this.fetchTransactions(transactionObj)
        },
        completePromotion(transactionId) {
            let userSelectedPlan = JSON.parse(localStorage.getItem('_m12sp60u'))
            // very important! It stops the page from going into loop! Removed by vuex after payment validation
            if(!userSelectedPlan) return
            let valueObj = {
                transactionId,
                itemId: this.item._id,
                userId: this.item.userId,
                plan: userSelectedPlan.codeName,
                cost: userSelectedPlan.price,
                duration: userSelectedPlan.duration,
                currency: userSelectedPlan.currency,
                link: `/market/listItem/${this.item._id}`, // for story
                linkText: this.item.title // for story
            }
            this.completePromoteItem(valueObj) 
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    // save transaction log for promotion
                    let eventObj = {
                        userId: this.user._id,
                        itemId: this.item._id,
                        promotionId: data.result.promotionId,
                        event: `applied ${data.result.selectedPlan.plan.toUpperCase()} promotion for ${data.result.selectedPlan.currency.toUpperCase()} ${data.result.selectedPlan.cost.toLocaleString()} - ${this.item.title}`
                    }
                    this.createTransaction(eventObj).then(() => {}).catch((e) => {})
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['postedItem', 'promotionPlans', 'user', 'transaction']),
        item() {
            if(this.postedItem && this.postedItem !== null){
                return this.postedItem
            }
            return false
        },
        thePromotionPlans() {
            if(this.promotionPlans && this.promotionPlans !== null){
                return this.promotionPlans
            }
            return false
        },
        itemTransaction() {
            if(this.transaction && this.transaction !== null){
                return this.transaction[0]
            }
            return false
        },
    },
    components: {
        appGhostMode: GhostMode
    },
    mounted() {
        this.runFetchItemDetails()
        if(this.$route.query.status && this.$route.query.status === "successful"){
            this.completePromotion(this.$route.query.transaction_id)
        } else {
            // if payment was not successful remove the already stored complete...Obj from localStorage
            if(localStorage.getItem('_m12sp60u')){
                localStorage.removeItem('_m12sp60u')
            }
        }
    }
}
</script>